import { motion } from "framer-motion";
import { PACKAGES } from "../data/content";
import { scrollToSection } from "../lib/lenisStore";

const EASE = [0.22, 1, 0.36, 1];

export default function Packages() {
  const choose = (option) => {
    window.dispatchEvent(new CustomEvent("select-package", { detail: option }));
    scrollToSection("contact");
  };

  return (
    <section id="packages" data-testid="packages-section" className="relative py-28 md:py-40 bg-[#0D0D10]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.header
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="max-w-2xl"
        >
          <p className="text-[11px] font-mono tracking-[0.25em] uppercase text-stone-500">
            04 // Collections
          </p>
          <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-normal tracking-tight text-ivory">
            Three Ways to <span className="italic text-champagne">Be Remembered</span>
          </h2>
          <p className="mt-4 text-sm font-light text-stone-400 leading-relaxed">
            Every commission is bespoke at its core. These collections are simply where the
            conversation begins.
          </p>
        </motion.header>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {PACKAGES.map((tier, i) => {
            const featured = Boolean(tier.badge);
            return (
              <motion.article
                key={tier.tier_id}
                data-testid={`package-card-${tier.tier_id}`}
                initial={{ opacity: 0, y: 48 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.9, delay: i * 0.12, ease: EASE }}
                className={`relative flex flex-col border p-8 transition-colors duration-500 ${
                  featured
                    ? "border-gold/40 bg-elevated md:-translate-y-4"
                    : "border-white/10 bg-surface hover:border-champagne/30"
                }`}
              >
                {featured && (
                  <span className="absolute -top-3 left-8 bg-gold px-3 py-1 text-[10px] font-mono tracking-[0.2em] uppercase text-obsidian">
                    {tier.badge}
                  </span>
                )}
                <p className="text-[10px] font-mono tracking-[0.25em] uppercase text-stone-500">
                  {tier.scope}
                </p>
                <h3 className="mt-3 font-serif text-xl sm:text-2xl text-ivory">{tier.name}</h3>
                <p className="mt-5 font-serif text-4xl font-light text-champagne">
                  {tier.investment}
                </p>
                <ul className="mt-7 space-y-3 flex-1">
                  {tier.highlights.map((h) => (
                    <li key={h} className="flex items-start gap-3 text-sm font-light text-stone-300">
                      <span className="mt-2 h-px w-5 bg-gold/50 shrink-0" />
                      {h}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`package-cta-${tier.tier_id}`}
                  onClick={() => choose(tier.option)}
                  className={`mt-8 py-3 text-[11px] font-mono tracking-[0.2em] uppercase transition-colors duration-300 ${
                    featured
                      ? "bg-champagne text-obsidian hover:bg-ivory"
                      : "border border-champagne/40 text-champagne hover:bg-champagne hover:text-obsidian"
                  }`}
                >
                  Reserve This Collection
                </button>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
